import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { io } from 'socket.io-client';

import {
  Chart,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const COLORS = [' #0a6e80ff', '#0f899f', '#16a3bc', '#26bad4', '#3acbe5', '#61dff6', '#82e7fa'];

const socket = io(process.env.REACT_APP_SOCKET_URL);
const ALL_MACHINES = ['Machine1', 'Machine2', 'Machine3', 'Machine4', 'Machine5', 'Machine6', 'Machine7'];

const BarParadasMaquina = () => {
  const [conteos, setConteos] = useState(() => {
    // Al iniciar, intenta cargar de sessionStorage
    const guardado = sessionStorage.getItem('conteosRPMBajo');
    return guardado ? JSON.parse(guardado) : {};
  });

  useEffect(() => {
    // Guardar en sessionStorage cada vez que cambie conteos
    sessionStorage.setItem('conteosRPMBajo', JSON.stringify(conteos));
  }, [conteos]);

useEffect(() => {
  const hoy = new Date().toISOString().slice(0, 10); // "YYYY-MM-DD"
  const lastDay = sessionStorage.getItem('rpmBajoLastDay');
  if (lastDay !== hoy) {
    sessionStorage.removeItem('conteosRPMBajo');
    sessionStorage.setItem('rpmBajoLastDay', hoy);
    setConteos({}); // Limpia el estado local también
  }
}, []);
useEffect(() => {
  socket.on('rpmBajo', ({ maquinaId, conteo }) => {
    setConteos(prev => ({
      ...prev,
      [maquinaId]: conteo
    }));
  });

  // Limpia el listener al desmontar el componente
  return () => {
    socket.off('rpmBajo');
  };
}, []);   

  // Siempre muestra todas las máquinas
  const labels = ALL_MACHINES;
  const data = labels.map(id => conteos[id] || 0);

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Conteo de RPM Bajo',
        data,
        backgroundColor: labels.map((_, i) => COLORS[i % COLORS.length]),
        borderRadius: 2,
      }
    ]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        labels: { color: '#8ab0cc' }
      },
      title: {
        display: true,
        text: 'Conteo de RPM Bajo por Máquina (Tiempo Real)',
        color: '#8ab0cc',
        font: { family: 'Roboto', size: 10 }
      }
    },
    scales: {
      x: {
        grid: { color: 'rgba(30,90,180,0.2)', borderDash: [], lineWidth: 0.3 },
        ticks: { color: '#8ab0cc' }
      },
      y: {
        grid: { color: 'rgba(30,90,180,0.2)', borderDash: [], lineWidth: 0.3 },
        ticks: { color: '#8ab0cc' }
      }
    }
  };

  return (
    <Bar data={chartData} options={options} height={280} />
  );
};

export default BarParadasMaquina;